module.exports = __webpack_public_path__ + "static/media/5 CCOS Meeting 2013.a7d88e77.pdf";